import {SectionTitle, InfoItem} from '@/components/molecules'

export const DeliveryAndStatusInfo = ({deliveryAndStausInfo}) => {
  const getVal = v => {
    if (typeof v === 'boolean') return v ? 'Yes' : 'No'
    return v !== undefined && v !== null ? v : '-'
  }

  return (
    <>
      {/* Identification Details Section */}

      <div className="order-overview">
        <div className="sc-border grid pl-4">
          <SectionTitle id="delivery_and_status" label="Delivery and Status Information" />
        </div>
        <div className="grid grid-cols-3 gap-4 pb-6 pl-4">
          <InfoItem label="Delivery Method" value={getVal(deliveryAndStausInfo?.deliveryMethod)} />
          <InfoItem label="Digital Address" value={getVal(deliveryAndStausInfo?.digitalAddress)} />

          <InfoItem label="Deposit" value={getVal(deliveryAndStausInfo?.deposit)} />
          <InfoItem label="Deposit with Line Item" value={getVal(deliveryAndStausInfo?.depositWithLineItem)} />
          <InfoItem label="Removed Status" value={getVal(deliveryAndStausInfo?.removedStatus)} />
          <InfoItem label="Additional Item Status" value={getVal(deliveryAndStausInfo?.additionalItemStatus)} />
          <InfoItem label="Replacement Product" value={getVal(deliveryAndStausInfo?.replacementProduct)} />
        </div>
      </div>
    </>
  )
}
